export default "__VITE_ASSET__BKXEabVJ__"